import { AuthService } from "../service/AuthService";

export const queryBuilder = (
    clean,
    conclusion,
    {
        info,
        currentPage = false,
        pageSize = false,
        typeCodeNum = false,
        preDate = false,
        postDate = false,
        senactId = false,
        senactValOrdr = false,
        startDate = false,
        endDate = false
    }
) => {
    let query = "";

    if (clean) {
        query = "query {";
    }

    const comCd = AuthService.getComCd();
    const param = Boolean((currentPage && pageSize) || (preDate && postDate));
    const commonPagination = currentPage === true ? ",CURRENT_PAGE:" + currentPage : "" +
        pageSize === true ? ",PAGE_SIZE:" + pageSize : "";
    const commonQuery = `(DEL_YN:"N"${commonPagination})`;

    const queryTemplates = getQueryTemplates(
        commonQuery,
        commonPagination,
        comCd,
        senactId,
        Number(senactValOrdr),
        startDate,
        endDate,
        typeCodeNum,
        preDate,
        postDate,
        param
    );

    query += queryTemplates[info];

    if (conclusion) {
        query += "}";
    }

    return query;
}


const getQueryTemplates = (
    commonQuery,
    commonPagination,
    comCd,
    senactId,
    senactValOrdr,
    startDate,
    endDate,
    typeCodeNum,
    preDate,
    postDate,
    param
) => {
    return {
        feedSchedule: `getFeedSchedule {
                        NO, SCHEDULE_TIME, RESERVATION_DATA, DEL_YN
                    }`,
        machine: `getMachineInfo${commonQuery}{
                  NO, BUILDING_ID, MACHINE_ID, MACHINE_NM, MACHINE_OP_MODE, MACHINE_SN, MACHINE_TOPIC, MACHINE_MODEL_NO,
                  MACHINE_PUB_IP, MACHINE_PUB_PORT, MACHINE_SERVER_IP, MACHINE_SERVER_PORT, MACHINE_LOCAL_IP, MACHINE_LOCAL_PORT,
                  MACHINE_MAPLE_ADDR_1, MACHINE_MAPLE_ADDR_2, MACHINE_MAPLE_ADDR_3, MACHINE_MAPLE_ADDR_4, MACHINE_MAPLE_ADDR_5,
                  MACHINE_LAST_CON, MEMO, DEL_YN
                }`,
        menu: `getMenuList {
                    NO, MENU_NAME, MENU_DESC, PARENT_MENU_NO, MENU_URL, MENU_ICON, MENU_ORDER, MENU_ENABLE, MENU_DISPLAY, MENU_LOGIN_CHECK
                }`
    };
}